import {
  ConditionType,
  FinanceType,
  GetTaxIncomeTypeListType,
  MerchantType,
  PaymentFlowType,
  PndType,
  SourceType,
  TaxIncomeType,
  TypeComponentNoti,
  VerifyType,
  WhtCertificateStatus,
  WhtCertificateTableSortColumnType,
  WhtCertificateTableViewStatusType,
  WHTCertItemType,
  WhtRateType,
} from "@/enums/enums";
import { i18n } from "@/i18n";
import store from "@/store";
import { GetMerchantBranchCode, GetMerchantFullName } from "./merchantHelper";
import { NewObject } from "./shareHelper";

export function GetQuickCreateWHTTemplate() {
  const quickCreateWHTTemplate = {
    contact: {
      value: { id: 0 },
      validateError: false,
    },
    issueDate: {
      value: new Date(),
      validateError: false,
    },
    incomeType: {
      value: { id: 0 },
      validateError: false,
    },
    description: {
      value: "",
      validateError: false,
    },
    netAmount: {
      value: "0.00",
      validateError: false,
    },
    whtRateType: {
      value: { id: 1 },
      validateError: false,
    },
    whtAmount: {
      value: "0.00",
      validateError: false,
    },
    referenceOne: {
      value: "",
      validateError: false,
    },
    referenceTwo: {
      value: "",
      validateError: false,
    },
  };

  return quickCreateWHTTemplate;
}

export function ValidateQuickCreateWHTTemplate(quickCreateWHTTemplate: any) {
  let validated = true;

  if (quickCreateWHTTemplate.contact.value && quickCreateWHTTemplate.contact.value.id > 0) {
    quickCreateWHTTemplate.contact.validateError = false;
  } else {
    quickCreateWHTTemplate.contact.validateError = true;
    validated = false;
  }

  if (quickCreateWHTTemplate.issueDate.value) {
    quickCreateWHTTemplate.issueDate.validateError = false;
  } else {
    quickCreateWHTTemplate.issueDate.validateError = true;
    validated = false;
  }

  if (quickCreateWHTTemplate.description.value.toString().length <= 100) {
    quickCreateWHTTemplate.description.validateError = false;
  } else {
    quickCreateWHTTemplate.description.validateError = true;
    validated = false;
  }

  if (quickCreateWHTTemplate.referenceOne.value.toString().length <= 35) {
    quickCreateWHTTemplate.referenceOne.validateError = false;
  } else {
    quickCreateWHTTemplate.referenceOne.validateError = true;
    validated = false;
  }

  if (quickCreateWHTTemplate.referenceTwo.value.toString().length <= 35) {
    quickCreateWHTTemplate.referenceTwo.validateError = false;
  } else {
    quickCreateWHTTemplate.referenceTwo.validateError = true;
    validated = false;
  }

  if (quickCreateWHTTemplate.netAmount.value.ToNumber() >= quickCreateWHTTemplate.whtAmount.value.ToNumber()) {
    quickCreateWHTTemplate.netAmount.validateError = false;
  } else {
    quickCreateWHTTemplate.whtAmount.validateError = true;
    validated = false;
  }
  if (quickCreateWHTTemplate.netAmount.value.ToNumber() > 0) {
    quickCreateWHTTemplate.netAmount.validateError = false;
  } else {
    quickCreateWHTTemplate.netAmount.validateError = true;
    validated = false;
  }
  return validated;
}

export function SetAlertMessageErrorQuickCreateWHT(quickCreateWHTTemplate: any) {
  let alertMessage = i18n.t("AlertNoti_Create_Input_Error");

  if (quickCreateWHTTemplate.netAmount.value.ToNumber() <= 0) {
    alertMessage = i18n.t("Text_Alert_Validate_WHT_Paid_Amount");
  } else if (quickCreateWHTTemplate.whtAmount.value.ToNumber() >= quickCreateWHTTemplate.netAmount.value.ToNumber()) {
    alertMessage = i18n.t("The_Amount_of_Tax");
  }

  store.dispatch(
    "Alert/SetAlertMessage",
    {
      alertMessage: alertMessage,
      typeMessage: TypeComponentNoti.error,
    },
    { root: true }
  );
}

function GetPndTypeForInsertWHT(quickCreateWHTTemplate: any) {
  let pndType = PndType.None;
  switch (quickCreateWHTTemplate.contact.value.contactType) {
    case MerchantType.OrdinaryPerson:
    case MerchantType.OrdinaryPartnership:
    case MerchantType.Shop:
    case MerchantType.BodyOfPersons:
      switch (quickCreateWHTTemplate.incomeType.value.id) {
        case TaxIncomeType.SalariesIncome:
        case TaxIncomeType.SalariesIncomeHaveWithholdingTaxRate:
        case TaxIncomeType.SeverancePay:
        case TaxIncomeType.SalariesWorkingIncome:
          pndType = PndType.PND1;
          break;

        case TaxIncomeType.GoodwillAndRightIncome:
        case TaxIncomeType.InterestOrDiscountIncome:
        case TaxIncomeType.ProfitSharingIncome:
        case TaxIncomeType.BonusToShareholder:
        case TaxIncomeType.PortionOfDecapitalized:
        case TaxIncomeType.IncreasedCapital:
        case TaxIncomeType.BenefitFromConsolidated:
        case TaxIncomeType.BenefitFromTrade:
          pndType = PndType.PND2;
          break;

        case TaxIncomeType.AssetRentalIncome:
        case TaxIncomeType.ProfessionalServiceIncome:
        case TaxIncomeType.ContractWorkIncome:
        case TaxIncomeType.HireOfWorkIncome:
        case TaxIncomeType.AdvertisingIncome:
        case TaxIncomeType.PrizeOrRewardIncome:
        case TaxIncomeType.OtherServicesExcludeHotelRestaurantAndInsurance:
        case TaxIncomeType.DiscountOrTradePromotion:
        case TaxIncomeType.Insurance:
        case TaxIncomeType.NonPublicTransport:
        case TaxIncomeType.CelebrityHiring:
          pndType = PndType.PND3;
          break;
      }
      break;

    case MerchantType.CompanyLimited:
    case MerchantType.PublicCompanyLimited:
    case MerchantType.LimitedLiabilityPartnership:
    case MerchantType.Foundation:
    case MerchantType.Association:
    case MerchantType.JointVenture:
    case MerchantType.Others:
      pndType = PndType.PND53;
      break;
  }

  return pndType;
}

export function ConvertToQuickInsertWHTCertificateModel(quickCreateWHTTemplate: any) {
  const quickInsertWHTCertificate = {
    contactId: quickCreateWHTTemplate.contact.value.id,
    whtDate: quickCreateWHTTemplate.issueDate.value.ToDateJsonString(),
    pndType: GetPndTypeForInsertWHT(quickCreateWHTTemplate),
    paymentFlowType: PaymentFlowType.CashOut,
    subTotal: quickCreateWHTTemplate.netAmount.value.ToNumber(),
    whtTotal: quickCreateWHTTemplate.whtAmount.value.ToNumber(),
    referenceOne: quickCreateWHTTemplate.referenceOne.value.toString(),
    referenceTwo: quickCreateWHTTemplate.referenceTwo.value.toString(),
    whtItemModelList: [] as any,
  };

  quickInsertWHTCertificate.whtItemModelList.push({
    whtRate: quickCreateWHTTemplate.whtRateType.value.value.ToNumber(),
    whtAmount: quickCreateWHTTemplate.whtAmount.value.ToNumber(),
    preTaxAmount: quickCreateWHTTemplate.netAmount.value.ToNumber(),
    taxIncomeType: quickCreateWHTTemplate.incomeType.value.id,
    description: quickCreateWHTTemplate.description.value.toString(),
  });

  return quickInsertWHTCertificate;
}

export function SetTapsWhtCertificateTable(tableView: any, count: any) {
  const taps = [
    {
      name: "Table_Tap_All",
      length: count.allCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: WhtCertificateTableViewStatusType.All,
      active: false,
    },
    {
      name: "Table_Tap_Draft",
      length: count.draftCount,
      bgLengthColor: "gray",
      showtableCount: true,
      tableViewStatusType: WhtCertificateTableViewStatusType.Draft,
      active: false,
    },
    {
      name: "Table_Tap_AwaitApprove",
      length: count.awaitApproveCount,
      bgLengthColor: "orange",
      showtableCount: true,
      tableViewStatusType: WhtCertificateTableViewStatusType.AwaitApproval,
      active: false,
    },
    {
      name: "Table_Tap_AwaitFiling",
      length: count.awaitFilingCount,
      bgLengthColor: "orange",
      showtableCount: true,
      tableViewStatusType: WhtCertificateTableViewStatusType.AwaitFiling,
      active: false,
    },
    {
      name: "Table_Tap_FiledTax",
      length: count.filedTaxCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: WhtCertificateTableViewStatusType.FiledTax,
      active: false,
    },
    {
      name: "Table_Tap_Void",
      length: count.voidedCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: WhtCertificateTableViewStatusType.Voided,
      active: false,
    },
  ];
  return taps;
}

export function SetHeaderWhtCertificateTable() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "WHT_No",
      sortBy: WhtCertificateTableSortColumnType.WhtCertificateNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "PND",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Date",
      sortBy: WhtCertificateTableSortColumnType.WhtCertificateDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Receiver",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Paid_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Wht_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Status",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
  ];
  return header;
}

export function GetTaxIncomeTypeList(getTaxIncomeTypeListType: GetTaxIncomeTypeListType) {
  let taxIncomeTypeListForExport = [];

  const taxIncomeTypeList = [
    {
      id: TaxIncomeType.SalariesIncome,
      name: i18n.t("IncomeType.SalariesIncome"),
      shortName: i18n.t("IncomeTypeShortName.SalariesIncome"),
      code: "40(1)1",
    },
    {
      id: TaxIncomeType.SalariesIncomeHaveWithholdingTaxRate,
      name: i18n.t("IncomeType.SalariesIncome_WHTRate"),
      shortName: i18n.t("IncomeTypeShortName.SalariesIncome"),
      code: "40(1)2",
    },
    {
      id: TaxIncomeType.SeverancePay,
      name: i18n.t("IncomeType.SeverancePay"),
      shortName: i18n.t("IncomeTypeShortName.SeverancePay"),
      code: "40(1)(2)",
    },
    {
      id: TaxIncomeType.SalariesWorkingIncome,
      name: i18n.t("IncomeType.SalariesWorkingIncome"),
      shortName: i18n.t("IncomeTypeShortName.SalariesWorkingIncome"),
      code: "40(2)",
    },
    {
      id: TaxIncomeType.GoodwillAndRightIncome,
      name: i18n.t("IncomeType.GoodWillAndRightIncome"),
      shortName: i18n.t("IncomeTypeShortName.GoodWillAndRightIncome"),
      code: "40(3)",
    },
    {
      id: TaxIncomeType.InterestOrDiscountIncome,
      name: i18n.t("IncomeType.DiscountIncome"),
      shortName: i18n.t("IncomeTypeShortName.DiscountIncome"),
      code: "40(4)ก",
    },
    {
      id: TaxIncomeType.ProfitSharingIncome,
      name: i18n.t("IncomeType.ProfitSharingIncome"),
      shortName: i18n.t("IncomeTypeShortName.ProfitSharingIncome"),
      code: "40(4)ข",
    },
    {
      id: TaxIncomeType.BonusToShareholder,
      name: i18n.t("IncomeType.BonusToShareHolder"),
      shortName: i18n.t("IncomeTypeShortName.BonusToShareHolder"),
      code: "40(4)ค",
    },
    {
      id: TaxIncomeType.PortionOfDecapitalized,
      name: i18n.t("IncomeType.PortionOfDecapitalized"),
      shortName: i18n.t("IncomeTypeShortName.PortionOfDecapitalized"),
      code: "40(4)ง",
    },
    {
      id: TaxIncomeType.IncreasedCapital,
      name: i18n.t("IncomeType.IncreasedCapital"),
      shortName: i18n.t("IncomeTypeShortName.IncreasedCapital"),
      code: "40(4)จ",
    },
    {
      id: TaxIncomeType.BenefitFromConsolidated,
      name: i18n.t("IncomeType.BenefitFromConsolidated"),
      shortName: i18n.t("IncomeTypeShortName.BenefitFromConsolidated"),
      code: "40(4)ฉ",
    },
    {
      id: TaxIncomeType.BenefitFromTrade,
      name: i18n.t("IncomeType.BenefitFromTrade"),
      shortName: i18n.t("IncomeTypeShortName.BenefitFromTrade"),
      code: "40(4)ช",
    },
    {
      id: TaxIncomeType.AssetRentalIncome,
      name: i18n.t("IncomeType.AssetRentalIncome"),
      shortName: i18n.t("IncomeTypeShortName.AssetRentalIncome"),
      code: "40(5)",
    },
    {
      id: TaxIncomeType.ProfessionalServiceIncome,
      name: i18n.t("IncomeType.ProfessionalServiceIncome"),
      shortName: i18n.t("IncomeTypeShortName.ProfessionalServiceIncome"),
      code: "40(6)",
    },
    {
      id: TaxIncomeType.ContractWorkIncome,
      name: i18n.t("IncomeType.ContractWorkIncome"),
      shortName: i18n.t("IncomeTypeShortName.ContractWorkIncome"),
      code: "40(7)",
    },
    {
      id: TaxIncomeType.HireOfWorkIncome,
      name: i18n.t("IncomeType.HireOfWorkIncome"),
      shortName: i18n.t("IncomeTypeShortName.HireOfWorkIncome"),
      code: "40(8)1",
    },
    {
      id: TaxIncomeType.AdvertisingIncome,
      name: i18n.t("IncomeType.AdvertisingIncome"),
      shortName: i18n.t("IncomeTypeShortName.AdvertisingIncome"),
      code: "40(8)2",
    },
    {
      id: TaxIncomeType.PrizeOrRewardIncome,
      name: i18n.t("IncomeType.PrizeOrRewardIncome"),
      shortName: i18n.t("IncomeTypeShortName.PrizeOrRewardIncome"),
      code: "40(8)3",
    },
    {
      id: TaxIncomeType.OtherServicesExcludeHotelRestaurantAndInsurance,
      name: i18n.t("IncomeType.OtherServicesExcludeHotelRestaurantAndInsurance"),
      shortName: i18n.t("IncomeTypeShortName.OtherServicesExcludeHotelRestaurantAndInsurance"),
      code: "40(8)4",
    },
    {
      id: TaxIncomeType.DiscountOrTradePromotion,
      name: i18n.t("IncomeType.DiscountOrTradePromotion"),
      shortName: i18n.t("IncomeTypeShortName.DiscountOrTradePromotion"),
      code: "40(8)5",
    },
    {
      id: TaxIncomeType.Insurance,
      name: i18n.t("IncomeType.Insurance"),
      shortName: i18n.t("IncomeTypeShortName.Insurance"),
      code: "40(8)6",
    },
    {
      id: TaxIncomeType.NonPublicTransport,
      name: i18n.t("IncomeType.NonPublicTransport"),
      shortName: i18n.t("IncomeTypeShortName.NonPublicTransport"),
      code: "40(8)7",
    },
    {
      id: TaxIncomeType.CelebrityHiring,
      name: i18n.t("IncomeType.CelebrityHiring"),
      shortName: i18n.t("IncomeTypeShortName.CelebrityHiring"),
      code: "40(8)8",
    },
  ];
  switch (getTaxIncomeTypeListType) {
    case GetTaxIncomeTypeListType.All:
      taxIncomeTypeListForExport = NewObject(taxIncomeTypeList);
      break;
    case GetTaxIncomeTypeListType.OrdinaryPerson:
      taxIncomeTypeListForExport = NewObject(taxIncomeTypeList);

      break;
    case GetTaxIncomeTypeListType.JuristicPerson:
      taxIncomeTypeList.forEach((taxIncomeType) => {
        switch (taxIncomeType.id) {
          case TaxIncomeType.SalariesWorkingIncome:
          case TaxIncomeType.GoodwillAndRightIncome:
          case TaxIncomeType.InterestOrDiscountIncome:
          case TaxIncomeType.ProfitSharingIncome:
          case TaxIncomeType.BonusToShareholder:
          case TaxIncomeType.PortionOfDecapitalized:
          case TaxIncomeType.IncreasedCapital:
          case TaxIncomeType.BenefitFromConsolidated:
          case TaxIncomeType.BenefitFromTrade:
          case TaxIncomeType.AssetRentalIncome:
          case TaxIncomeType.ProfessionalServiceIncome:
          case TaxIncomeType.ContractWorkIncome:
          case TaxIncomeType.HireOfWorkIncome:
          case TaxIncomeType.AdvertisingIncome:
          case TaxIncomeType.PrizeOrRewardIncome:
          case TaxIncomeType.OtherServicesExcludeHotelRestaurantAndInsurance:
          case TaxIncomeType.DiscountOrTradePromotion:
          case TaxIncomeType.Insurance:
          case TaxIncomeType.NonPublicTransport:
          case TaxIncomeType.CelebrityHiring:
            taxIncomeTypeListForExport.push(NewObject(taxIncomeType));
            break;
        }
      });

      break;
    case GetTaxIncomeTypeListType.WHTCertItem401:
      taxIncomeTypeList.forEach((taxIncomeType) => {
        switch (taxIncomeType.id) {
          case TaxIncomeType.SalariesIncome:
          case TaxIncomeType.SalariesIncomeHaveWithholdingTaxRate:
          case TaxIncomeType.SeverancePay:
            taxIncomeTypeListForExport.push(NewObject(taxIncomeType));
            break;
        }
      });

      break;
    case GetTaxIncomeTypeListType.WHTCertItem402:
      taxIncomeTypeList.forEach((taxIncomeType) => {
        switch (taxIncomeType.id) {
          case TaxIncomeType.SalariesWorkingIncome:
            taxIncomeTypeListForExport.push(NewObject(taxIncomeType));
            break;
        }
      });

      break;
    case GetTaxIncomeTypeListType.WHTCertItem403:
      taxIncomeTypeList.forEach((taxIncomeType) => {
        switch (taxIncomeType.id) {
          case TaxIncomeType.GoodwillAndRightIncome:
            taxIncomeTypeListForExport.push(NewObject(taxIncomeType));
            break;
        }
      });

      break;
    case GetTaxIncomeTypeListType.WHTCertItem404A:
      taxIncomeTypeList.forEach((taxIncomeType) => {
        switch (taxIncomeType.id) {
          case TaxIncomeType.InterestOrDiscountIncome:
          case TaxIncomeType.ProfitSharingIncome:
          case TaxIncomeType.BonusToShareholder:
          case TaxIncomeType.PortionOfDecapitalized:
          case TaxIncomeType.IncreasedCapital:
          case TaxIncomeType.BenefitFromConsolidated:
          case TaxIncomeType.BenefitFromTrade:
            taxIncomeTypeListForExport.push(NewObject(taxIncomeType));
            break;
        }
      });

      break;
    case GetTaxIncomeTypeListType.WHTCertItem40X1:
    case GetTaxIncomeTypeListType.WHTCertItem40X2:
    case GetTaxIncomeTypeListType.WHTCertItem40X3:
    case GetTaxIncomeTypeListType.WHTCertItemOther:
      taxIncomeTypeList.forEach((taxIncomeType) => {
        switch (taxIncomeType.id) {
          case TaxIncomeType.AssetRentalIncome:
          case TaxIncomeType.ProfessionalServiceIncome:
          case TaxIncomeType.ContractWorkIncome:
          case TaxIncomeType.HireOfWorkIncome:
          case TaxIncomeType.AdvertisingIncome:
          case TaxIncomeType.PrizeOrRewardIncome:
          case TaxIncomeType.OtherServicesExcludeHotelRestaurantAndInsurance:
          case TaxIncomeType.DiscountOrTradePromotion:
          case TaxIncomeType.Insurance:
          case TaxIncomeType.NonPublicTransport:
          case TaxIncomeType.CelebrityHiring:
            taxIncomeTypeListForExport.push(NewObject(taxIncomeType));
            break;
        }
      });

      break;
  }
  return taxIncomeTypeListForExport;
}

export function GetTaxIncomeTypeForWithholdingFullCreate(whtCertItemType: WHTCertItemType) {
  const taxIncomeTypeTemplate = {
    active: false,
    whtCertItemType: whtCertItemType,
    date: {
      value: new Date().GetDateFormat(),
      validateError: false,
    },
    incomeType: {
      value: -1,
      validateError: false,
    },
    newAmount: {
      value: 0,
      validateError: false,
    },
    whtAmount: {
      value: 0,
      validateError: false,
    },
    whtRateType: {
      id: 0,
      value: 0,
      validateError: false,
    },
    description: {
      value: "",
      validateError: false,
    },
  };
  return taxIncomeTypeTemplate;
}
export function GetInsertWhtCertificateTemplate() {
  const insertWhtCertificateTemplate = {
    id: 0,
    issueDate: new Date(),
    paymentFlowType: FinanceType.OutFlow,
    sourceType: SourceType.PeakTax,
    sourceId: 0,
    status: 0,
    WhtCertCondition: {
      value: ConditionType.WithholdingTax,
    },
    number: {
      value: "",
      default: "",
      validateError: false,
    },
    issuerTaxID: {
      value: "",
      validateError: false,
    },
    issuerName: {
      value: "",
      validateError: false,
    },
    issuerAddress: {
      value: "",
      validateError: false,
    },
    referenceOne: {
      value: "",
      validateError: false,
    },
    referenceTwo: {
      value: "",
      validateError: false,
    },
    contact: {
      id: 0,
      contactCode: "",
      contactBranchCode: "",
      contactType: MerchantType.None,
      taxID: {
        value: "",
        validateError: false,
      },
      name: {
        value: "",
        validateError: false,
      },
      address: {
        value: "",
        validateError: false,
      },
    },
    pndType: PndType.None,
    taxIncomeType: {
      whtCertItem401: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem401),
      whtCertItem402: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem402),
      whtCertItem403: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem403),
      whtCertItem404A: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem404A),
      whtCertItem40X1: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem40X1),
      whtCertItem40X2: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem40X2),
      whtCertItem40X3: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem40X3),
      whtCertItemOther: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItemOther),
    },
    summary: {
      newAmount: {
        value: 0,
        validateError: false,
      },
      withholdingTax: {
        value: 0,
        validateError: false,
      },
      newAmountTextTh: "",
    },
    pensionFund: {
      value: 0,
      validateError: false,
    },
    socialSecurityFund: {
      value: 0,
      validateError: false,
    },
    providentFund: {
      value: 0,
      validateError: false,
    },
  };

  return insertWhtCertificateTemplate;
}

export function ValidateInsertWhtCertificateTemplate(insertWhtCertificateTemplate: any) {
  let validated = true;
  let textError: any = "";

  if (insertWhtCertificateTemplate.number.value && insertWhtCertificateTemplate.number.value.toString().length > 0) {
    insertWhtCertificateTemplate.number.validateError = false;
  } else {
    insertWhtCertificateTemplate.number.validateError = true;
    validated = false;
    textError = i18n.t("Please_fill_in_WHT_number");
  }

  if (insertWhtCertificateTemplate.contact.id && insertWhtCertificateTemplate.contact.id > 0) {
    insertWhtCertificateTemplate.contact.name.validateError = false;
    insertWhtCertificateTemplate.contact.address.validateError = false;
  } else {
    insertWhtCertificateTemplate.contact.name.validateError = true;
    insertWhtCertificateTemplate.contact.address.validateError = true;
    validated = false;
    textError = i18n.t("Please_select_contact");
  }

  if (insertWhtCertificateTemplate.referenceOne.value.toString().length <= 35) {
    insertWhtCertificateTemplate.referenceOne.validateError = false;
  } else {
    insertWhtCertificateTemplate.referenceOne.validateError = true;
    validated = false;
    textError = i18n.t("Alert_Less_Than_Character");
  }

  if (insertWhtCertificateTemplate.referenceTwo.value.toString().length <= 35) {
    insertWhtCertificateTemplate.referenceTwo.validateError = false;
  } else {
    insertWhtCertificateTemplate.referenceTwo.validateError = true;
    validated = false;
    textError = i18n.t("Alert_Less_Than_Character");
  }

  if (!(insertWhtCertificateTemplate.pndType > PndType.None)) {
    validated = false;
    textError = i18n.t("Please_select_PND_type");
  }

  if (
    insertWhtCertificateTemplate.summary.newAmount.value.ToNumber() <=
    insertWhtCertificateTemplate.summary.withholdingTax.value.ToNumber()
  ) {
    validated = false;
    textError = i18n.t("Text_Alert_Validate_WHT_Paid_Amount");
  }

  let isHaveTaxIncomeType = false;

  for (const key of Object.keys(insertWhtCertificateTemplate.taxIncomeType)) {
    const taxIncomeType = insertWhtCertificateTemplate.taxIncomeType[key];
    if (taxIncomeType.active && taxIncomeType.incomeType.value >= 0) {
      isHaveTaxIncomeType = true;
    }
  }

  if (!isHaveTaxIncomeType) {
    validated = false;
    textError = i18n.t("Please_select_income_type");
  }

  return { validated: validated, textError: textError };
}

export function ConvertToInsertWhtCertificateModel(insertWhtCertificateTemplate: any) {
  const insertWhtCertificateModel = {
    id: insertWhtCertificateTemplate.id,
    whtNumber: insertWhtCertificateTemplate.number.default + insertWhtCertificateTemplate.number.value,
    whtDate: insertWhtCertificateTemplate.issueDate,
    conditionType: insertWhtCertificateTemplate.WhtCertCondition.value,
    referenceOne: insertWhtCertificateTemplate.referenceOne.value,
    referenceTwo: insertWhtCertificateTemplate.referenceTwo.value,
    contactId: insertWhtCertificateTemplate.contact.id,
    paymentFlowType: insertWhtCertificateTemplate.paymentFlowType,
    pndType: insertWhtCertificateTemplate.pndType,
    subTotal: insertWhtCertificateTemplate.summary.newAmount.value.ToNumber(),
    whtTotal: insertWhtCertificateTemplate.summary.withholdingTax.value.ToNumber(),
    pensionFundAmount: insertWhtCertificateTemplate.pensionFund.value.ToNumber(),
    socialSecurityAmount: insertWhtCertificateTemplate.socialSecurityFund.value.ToNumber(),
    providentFundAmount: insertWhtCertificateTemplate.providentFund.value.ToNumber(),
    sourceType: insertWhtCertificateTemplate.sourceType,
    sourceId: insertWhtCertificateTemplate.sourceId,
    status: insertWhtCertificateTemplate.status,
    whtItemModelList: [] as any,
  };

  if (insertWhtCertificateTemplate.isUpdateFromPeakAccount) {
    insertWhtCertificateModel.whtItemModelList = insertWhtCertificateTemplate.whtItemModelList;
  } else {
    for (const key of Object.keys(insertWhtCertificateTemplate.taxIncomeType)) {
      const taxIncomeType = insertWhtCertificateTemplate.taxIncomeType[key];
      if (taxIncomeType.active && taxIncomeType.incomeType.value >= 0) {
        insertWhtCertificateModel.whtItemModelList.push({
          whtRate: taxIncomeType.whtRateType.value.ToNumber(),
          whtAmount: taxIncomeType.whtAmount.value.ToNumber(),
          preTaxAmount: taxIncomeType.newAmount.value.ToNumber(),
          taxIncomeType: taxIncomeType.incomeType.value,
          description: taxIncomeType.description.value,
        });
      }
    }
  }

  return insertWhtCertificateModel;
}

export function ConvertToWhtRateType(whtRate: any) {
  let whtRateType = WhtRateType.None;
  switch (whtRate.ToNumber()) {
    case 0:
      whtRateType = WhtRateType.Custom;
      break;
    case 0.75:
      whtRateType = WhtRateType.ZeroPointSevenFive;
      break;
    case 1:
      whtRateType = WhtRateType.OnePercent;
      break;
    case 2:
      whtRateType = WhtRateType.TwoPercent;
      break;
    case 3:
      whtRateType = WhtRateType.ThreePercent;
      break;
    case 5:
      whtRateType = WhtRateType.FivePercent;
      break;
    case 10:
      whtRateType = WhtRateType.TenPercent;
      break;
    case 15:
      whtRateType = WhtRateType.FifteenPercent;
      break;
    case 1.5:
      whtRateType = WhtRateType.OnePointFivePercent;
      break;
  }
  return whtRateType;
}

export function SetTaxIncomeTypeWhtCertificate(whtItemModelList: Array<any>, whtCertificateTemplate: any) {
  if (whtItemModelList && whtItemModelList.length > 0) {
    let isHaveWhtCertItem404A = false;
    whtItemModelList.forEach((whtItemModel: any) => {
      switch (whtItemModel.taxIncomeType) {
        //WHTCertItem401
        case TaxIncomeType.SalariesIncome:
        case TaxIncomeType.SalariesIncomeHaveWithholdingTaxRate:
        case TaxIncomeType.SeverancePay:
          whtCertificateTemplate.taxIncomeType.whtCertItem401.incomeType.value = whtItemModel.taxIncomeType;
          whtCertificateTemplate.taxIncomeType.whtCertItem401.newAmount.value += whtItemModel.preTaxAmount;
          whtCertificateTemplate.taxIncomeType.whtCertItem401.whtAmount.value += whtItemModel.whtAmount;
          whtCertificateTemplate.taxIncomeType.whtCertItem401.whtRateType.id = ConvertToWhtRateType(
            whtItemModel.whtRate
          );
          whtCertificateTemplate.taxIncomeType.whtCertItem401.whtRateType.value = whtItemModel.whtRate;
          whtCertificateTemplate.taxIncomeType.whtCertItem401.description.value = whtItemModel.description;
          break;

        //WHTCertItem402
        case TaxIncomeType.SalariesWorkingIncome:
          whtCertificateTemplate.taxIncomeType.whtCertItem402.incomeType.value = whtItemModel.taxIncomeType;
          whtCertificateTemplate.taxIncomeType.whtCertItem402.newAmount.value += whtItemModel.preTaxAmount;
          whtCertificateTemplate.taxIncomeType.whtCertItem402.whtAmount.value += whtItemModel.whtAmount;
          whtCertificateTemplate.taxIncomeType.whtCertItem402.whtRateType.id = ConvertToWhtRateType(
            whtItemModel.whtRate
          );
          whtCertificateTemplate.taxIncomeType.whtCertItem402.whtRateType.value = whtItemModel.whtRate;
          whtCertificateTemplate.taxIncomeType.whtCertItem402.description.value = whtItemModel.description;
          break;
        //WHTCertItem403
        case TaxIncomeType.GoodwillAndRightIncome:
          whtCertificateTemplate.taxIncomeType.whtCertItem403.incomeType.value = whtItemModel.taxIncomeType;
          whtCertificateTemplate.taxIncomeType.whtCertItem403.newAmount.value += whtItemModel.preTaxAmount;
          whtCertificateTemplate.taxIncomeType.whtCertItem403.whtAmount.value += whtItemModel.whtAmount;
          whtCertificateTemplate.taxIncomeType.whtCertItem403.whtRateType.id = ConvertToWhtRateType(
            whtItemModel.whtRate
          );
          whtCertificateTemplate.taxIncomeType.whtCertItem403.whtRateType.value = whtItemModel.whtRate;
          whtCertificateTemplate.taxIncomeType.whtCertItem403.description.value = whtItemModel.description;
          break;
        //WHTCertItem404A
        case TaxIncomeType.InterestOrDiscountIncome:
        case TaxIncomeType.ProfitSharingIncome:
        case TaxIncomeType.BonusToShareholder:
        case TaxIncomeType.PortionOfDecapitalized:
        case TaxIncomeType.IncreasedCapital:
        case TaxIncomeType.BenefitFromConsolidated:
        case TaxIncomeType.BenefitFromTrade:
          whtCertificateTemplate.taxIncomeType.whtCertItem404A.incomeType.value = isHaveWhtCertItem404A
            ? TaxIncomeType.BenefitFromTrade
            : whtItemModel.taxIncomeType;
          whtCertificateTemplate.taxIncomeType.whtCertItem404A.newAmount.value += whtItemModel.preTaxAmount;
          whtCertificateTemplate.taxIncomeType.whtCertItem404A.whtAmount.value += whtItemModel.whtAmount;
          if (isHaveWhtCertItem404A) {
            //เช็ค whtRateType เหมือนกันหมดไหม หากไม่ให้เซ็ตเป็น Custom
            whtCertificateTemplate.taxIncomeType.whtCertItem404A.whtRateType.id =
              whtCertificateTemplate.taxIncomeType.whtCertItem404A.whtRateType.id ===
              ConvertToWhtRateType(whtItemModel.whtRate)
                ? whtCertificateTemplate.taxIncomeType.whtCertItem404A.whtRateType.id
                : WhtRateType.Custom;
          } else {
            whtCertificateTemplate.taxIncomeType.whtCertItem404A.whtRateType.id = ConvertToWhtRateType(
              whtItemModel.whtRate
            );
          }
          whtCertificateTemplate.taxIncomeType.whtCertItem404A.description.value += whtCertificateTemplate.taxIncomeType
            .whtCertItem404A.description.value
            ? ", " + whtItemModel.description
            : whtItemModel.description;
          whtCertificateTemplate.taxIncomeType.whtCertItem404A.whtRateType.value = whtItemModel.whtRate;
          isHaveWhtCertItem404A = true;

          break;
        //WHTCertItem40X
        case TaxIncomeType.ProfessionalServiceIncome:
        case TaxIncomeType.ContractWorkIncome:
        case TaxIncomeType.HireOfWorkIncome:
        case TaxIncomeType.AdvertisingIncome:
        case TaxIncomeType.PrizeOrRewardIncome:
        case TaxIncomeType.OtherServicesExcludeHotelRestaurantAndInsurance:
        case TaxIncomeType.DiscountOrTradePromotion:
        case TaxIncomeType.Insurance:
        case TaxIncomeType.NonPublicTransport:
        case TaxIncomeType.CelebrityHiring:
        case TaxIncomeType.AssetRentalIncome:
          if (whtCertificateTemplate.taxIncomeType.whtCertItem40X1.incomeType.value == -1) {
            whtCertificateTemplate.taxIncomeType.whtCertItem40X1.incomeType.value = whtItemModel.taxIncomeType;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X1.newAmount.value = whtItemModel.preTaxAmount;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X1.whtAmount.value = whtItemModel.whtAmount;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X1.whtRateType.id = ConvertToWhtRateType(
              whtItemModel.whtRate
            );
            whtCertificateTemplate.taxIncomeType.whtCertItem40X1.whtRateType.value = whtItemModel.whtRate;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X1.description.value = whtItemModel.description;
          } else if (whtCertificateTemplate.taxIncomeType.whtCertItem40X2.incomeType.value == -1) {
            whtCertificateTemplate.taxIncomeType.whtCertItem40X2.incomeType.value = whtItemModel.taxIncomeType;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X2.newAmount.value = whtItemModel.preTaxAmount;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X2.whtAmount.value = whtItemModel.whtAmount;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X2.whtRateType.id = ConvertToWhtRateType(
              whtItemModel.whtRate
            );
            whtCertificateTemplate.taxIncomeType.whtCertItem40X2.whtRateType.value = whtItemModel.whtRate;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X2.description.value = whtItemModel.description;
          } else if (whtCertificateTemplate.taxIncomeType.whtCertItem40X3.incomeType.value == -1) {
            whtCertificateTemplate.taxIncomeType.whtCertItem40X3.incomeType.value = whtItemModel.taxIncomeType;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X3.newAmount.value = whtItemModel.preTaxAmount;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X3.whtAmount.value = whtItemModel.whtAmount;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X3.whtRateType.id = ConvertToWhtRateType(
              whtItemModel.whtRate
            );
            whtCertificateTemplate.taxIncomeType.whtCertItem40X3.whtRateType.value = whtItemModel.whtRate;
            whtCertificateTemplate.taxIncomeType.whtCertItem40X3.description.value = whtItemModel.description;
          } else if (whtCertificateTemplate.taxIncomeType.whtCertItemOther.incomeType.value == -1) {
            whtCertificateTemplate.taxIncomeType.whtCertItemOther.incomeType.value = whtItemModel.taxIncomeType;
            whtCertificateTemplate.taxIncomeType.whtCertItemOther.newAmount.value = whtItemModel.preTaxAmount;
            whtCertificateTemplate.taxIncomeType.whtCertItemOther.whtAmount.value = whtItemModel.whtAmount;
            whtCertificateTemplate.taxIncomeType.whtCertItemOther.whtRateType.id = ConvertToWhtRateType(
              whtItemModel.whtRate
            );
            whtCertificateTemplate.taxIncomeType.whtCertItemOther.whtRateType.value = whtItemModel.whtRate;
            whtCertificateTemplate.taxIncomeType.whtCertItemOther.description.value = whtItemModel.description;
          }

          break;
        case TaxIncomeType.None:
          whtCertificateTemplate.taxIncomeType.whtCertItemOther.incomeType.value = whtItemModel.taxIncomeType;
          whtCertificateTemplate.taxIncomeType.whtCertItemOther.newAmount.value += whtItemModel.preTaxAmount;
          whtCertificateTemplate.taxIncomeType.whtCertItemOther.whtAmount.value += whtItemModel.whtAmount;
          whtCertificateTemplate.taxIncomeType.whtCertItemOther.whtRateType.id = WhtRateType.Custom;
          whtCertificateTemplate.taxIncomeType.whtCertItemOther.whtRateType.value = whtItemModel.whtRate;
          whtCertificateTemplate.taxIncomeType.whtCertItemOther.description.value += whtCertificateTemplate
            .taxIncomeType.whtCertItemOther.description.value
            ? ", " + whtItemModel.description
            : whtItemModel.description;
          break;
      }
    });
  }

  return whtCertificateTemplate.taxIncomeType;
}

export function SetWhtCertificateDetailForEdit(whtCertificateDetail: any, whtSuggestHeader: string) {
  const whtCertificateTemplate = GetInsertWhtCertificateTemplate();
  whtCertificateTemplate.id = whtCertificateDetail.id;
  whtCertificateTemplate.referenceOne.value = whtCertificateDetail.referenceOne
    ? whtCertificateDetail.referenceOne
    : "";
  whtCertificateTemplate.referenceTwo.value = whtCertificateDetail.referenceTwo
    ? whtCertificateDetail.referenceTwo
    : "";
  whtCertificateTemplate.issueDate = new Date(whtCertificateDetail.whtDate);
  whtCertificateTemplate.paymentFlowType = whtCertificateDetail.paymentFlowType
    ? whtCertificateDetail.paymentFlowType
    : FinanceType.None;
  whtCertificateTemplate.sourceType = whtCertificateDetail.sourceType;
  whtCertificateTemplate.sourceId = whtCertificateDetail.sourceId;
  whtCertificateTemplate.status = whtCertificateDetail.status;
  whtCertificateTemplate.WhtCertCondition = {
    value: whtCertificateDetail.conditionType ? whtCertificateDetail.conditionType : ConditionType.None,
  };

  whtCertificateTemplate.pndType = whtCertificateDetail.pndType;
  whtCertificateTemplate.number.value = whtCertificateDetail.whtNumber ? whtCertificateDetail.whtNumber : "";
  if (whtCertificateDetail.whtNumber) {
    if (whtSuggestHeader && whtSuggestHeader.length <= whtCertificateDetail.whtNumber.length) {
      const whtHeader = whtCertificateDetail.whtNumber.substring(0, whtSuggestHeader.length);
      if (whtHeader == whtSuggestHeader) {
        const runningNumber = whtCertificateDetail.whtNumber.substring(whtSuggestHeader.length);
        whtCertificateTemplate.number.value = runningNumber;
        whtCertificateTemplate.number.default = whtSuggestHeader;
      }
    }
  }

  whtCertificateTemplate.contact.id = whtCertificateDetail.contactId;
  whtCertificateTemplate.contact.contactCode = whtCertificateDetail.contactCode;
  whtCertificateTemplate.contact.contactType = whtCertificateDetail.contactType;
  whtCertificateTemplate.contact.taxID.value = whtCertificateDetail.contactTaxId;
  whtCertificateTemplate.contact.name.value = whtCertificateDetail.contactFullName;
  whtCertificateTemplate.contact.name.value += GetMerchantBranchCode(whtCertificateDetail.contactBranchCode);
  whtCertificateTemplate.contact.address.value = whtCertificateDetail.contactAddress ? whtCertificateDetail.contactAddress : "-";

  whtCertificateTemplate.pensionFund.value = whtCertificateDetail.pensionFundAmount;
  whtCertificateTemplate.socialSecurityFund.value = whtCertificateDetail.socialSecurityAmount;
  whtCertificateTemplate.providentFund.value = whtCertificateDetail.providentFundAmount;
  whtCertificateTemplate.taxIncomeType = SetTaxIncomeTypeWhtCertificate(
    whtCertificateDetail.whtItemModelList,
    whtCertificateTemplate
  );

  return whtCertificateTemplate;
}

export function GetWhtRateTypeDefault(incomeType: TaxIncomeType, _contactType: MerchantType) {
  let contactType = 0;
  let whtRateType = WhtRateType.None;
  switch (_contactType) {
    case MerchantType.OrdinaryPerson:
    case MerchantType.OrdinaryPartnership:
    case MerchantType.Shop:
    case MerchantType.BodyOfPersons:
      contactType = 1;
      break;

    case MerchantType.CompanyLimited:
    case MerchantType.PublicCompanyLimited:
    case MerchantType.LimitedLiabilityPartnership:
    case MerchantType.JointVenture:
    case MerchantType.Others:
      contactType = 2;
      break;

    case MerchantType.Foundation:
    case MerchantType.Association:
      contactType = 3;
      break;
  }

  switch (incomeType) {
    case TaxIncomeType.SalariesIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.Custom;
          break;
        case 2:
          whtRateType = WhtRateType.Custom;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.SalariesIncomeHaveWithholdingTaxRate:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 2:
          whtRateType = WhtRateType.Custom;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.SeverancePay:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.Custom;
          break;
        case 2:
          whtRateType = WhtRateType.Custom;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.SalariesWorkingIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.Custom;
          break;
        case 2:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 3:
          whtRateType = WhtRateType.TenPercent;
          break;
      }
      break;

    case TaxIncomeType.GoodwillAndRightIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.Custom;
          break;
        case 2:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 3:
          whtRateType = WhtRateType.TenPercent;
          break;
      }
      break;

    case TaxIncomeType.InterestOrDiscountIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.FifteenPercent;
          break;
        case 2:
          whtRateType = WhtRateType.OnePercent;
          break;
        case 3:
          whtRateType = WhtRateType.TenPercent;
          break;
      }
      break;
    case TaxIncomeType.ProfitSharingIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.TenPercent;
          break;
        case 2:
          whtRateType = WhtRateType.TenPercent;
          break;
        case 3:
          whtRateType = WhtRateType.TenPercent;
          break;
      }
      break;
    case TaxIncomeType.BonusToShareholder:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.Custom;
          break;
        case 2:
          whtRateType = WhtRateType.Custom;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.PortionOfDecapitalized:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.Custom;
          break;
        case 2:
          whtRateType = WhtRateType.Custom;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.IncreasedCapital:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.Custom;
          break;
        case 2:
          whtRateType = WhtRateType.Custom;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.BenefitFromConsolidated:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.Custom;
          break;
        case 2:
          whtRateType = WhtRateType.Custom;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;

    case TaxIncomeType.BenefitFromTrade:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.Custom;
          break;
        case 2:
          whtRateType = WhtRateType.Custom;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;

    case TaxIncomeType.AssetRentalIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.FivePercent;
          break;
        case 2:
          whtRateType = WhtRateType.FivePercent;
          break;
        case 3:
          whtRateType = WhtRateType.TenPercent;
          break;
      }
      break;

    case TaxIncomeType.ProfessionalServiceIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 2:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.ContractWorkIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 2:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.HireOfWorkIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 2:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.AdvertisingIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.TwoPercent;
          break;
        case 2:
          whtRateType = WhtRateType.TwoPercent;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.PrizeOrRewardIncome:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.FivePercent;
          break;
        case 2:
          whtRateType = WhtRateType.FivePercent;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.OtherServicesExcludeHotelRestaurantAndInsurance:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 2:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.DiscountOrTradePromotion:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 2:
          whtRateType = WhtRateType.ThreePercent;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.Insurance:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.Custom;
          break;
        case 2:
          whtRateType = WhtRateType.OnePercent;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.NonPublicTransport:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.OnePercent;
          break;
        case 2:
          whtRateType = WhtRateType.OnePercent;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
    case TaxIncomeType.CelebrityHiring:
      switch (contactType) {
        case 1:
          whtRateType = WhtRateType.FivePercent;
          break;
        case 2:
          whtRateType = WhtRateType.Custom;
          break;
        case 3:
          whtRateType = WhtRateType.Custom;
          break;
      }
      break;
  }

  return whtRateType;
}

export function GetVerifyType(whtDetail: any) {
  const verifyContactType = whtDetail.verifyContactType;
  const verifyContactText = whtDetail.verifyContactText;
  const verifyType = whtDetail.verifyType;
  const verifyText = whtDetail.verifyText;
  let className = "";
  const contentList: any = [];

  if (verifyContactType == VerifyType.Fail || verifyType == VerifyType.Fail) {
    className = "fail";
  } else if (verifyContactType == VerifyType.Warn || verifyType == VerifyType.Warn) {
    className = "warn";
  } else if (verifyContactType == VerifyType.Success && verifyType == VerifyType.Success) {
    className = "success";
    contentList.push(verifyContactText);
  }

  if (verifyContactType == VerifyType.Fail) {
    contentList.push(verifyContactText);
  }

  if (verifyType == VerifyType.Fail) {
    contentList.push(verifyText);
  }

  if (verifyContactType == VerifyType.Warn) {
    contentList.push(verifyContactText);
  }

  if (verifyType == VerifyType.Warn) {
    contentList.push(verifyText);
  }

  return { className: className, contentList: contentList };
}

export function GetWhtCertificateStatus(whtCertificateStatus: WhtCertificateStatus) {
  let whtStatus: any = "";
  let className = "";

  switch (whtCertificateStatus) {
    case WhtCertificateStatus.Draft:
      whtStatus = i18n.t("Table_Tap_Draft");
      className = "statusDraft";
      break;
    case WhtCertificateStatus.AwaitApproval:
      whtStatus = i18n.t("Table_Tap_AwaitApprove");
      className = "statusAwaitApproval";
      break;
    case WhtCertificateStatus.AwaitFiling:
      whtStatus = i18n.t("Table_Tap_AwaitFiling");
      className = "statusAwaitFiling";
      break;
    case WhtCertificateStatus.FiledTax:
      whtStatus = i18n.t("Table_Tap_FiledTax");
      className = "statusFiledTax";
      break;
  }

  return { name: whtStatus, class: className };
}
